var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-upload',{ref:"upload",attrs:{"size":4096 * 2048,"accept":_vm.allowedFileTypes,"data":{
    direct_upload_url: '/api/v1/widget/direct_uploads',
    direct_upload: true,
  }},on:{"input-file":_vm.onFileUpload}},[_c('button',{staticClass:"icon-button flex items-center justify-center"},[(!_vm.isUploading.image)?_c('fluent-icon',{attrs:{"icon":"attach"}}):_vm._e(),_vm._v(" "),(_vm.isUploading)?_c('spinner',{attrs:{"size":"small"}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }